import './index.scss';

import { useTranslation } from 'react-i18next';

import ContextMenu from '@components/ContextMenu';
import { TrashCanIcon } from '@components/SongContextMenu';

import infoIcon from 'url:@assets/icons/infocircle.svg';
import bookIcon from 'url:@assets/icons/book.svg';
import pencilIcon from 'url:@assets/icons/pencil.svg';

export type VolunteerContextMenuProps = {
  personName: string;
  x: number;
  y: number;
  isClosing: boolean;
  onRequestClose?: () => void;
  onDetails: () => void;
  onEditRoles: () => void;
  onAssignedTraining: () => void;
  onRemoveFromTeam: () => void;
};

export default function VolunteerContextMenu(props: VolunteerContextMenuProps) {
  const { t } = useTranslation('volunteering');

  return <ContextMenu
    className='volunteer-context-menu'
    x={props.x}
    y={props.y}
    isClosing={props.isClosing}
    onRequestClose={props.onRequestClose}
    sections={[
      {
        className: 'volunteer-context-menu-actions',
        items: [
          {
            key: 'details',
            className: 'volunteer-context-action',
            onClick: props.onDetails,
            content: <>
              <img src={infoIcon} alt='' aria-hidden='true' />
              <span>{t('menu.details')}</span>
            </>
          },
          {
            key: 'edit-roles',
            className: 'volunteer-context-action',
            onClick: props.onEditRoles,
            content: <>
              <img src={pencilIcon} alt='' aria-hidden='true' />
              <span>{t('menu.editRoles')}</span>
            </>
          },
          {
            key: 'assigned-training',
            className: 'volunteer-context-action',
            onClick: props.onAssignedTraining,
            content: <>
              <img src={bookIcon} alt='' aria-hidden='true' />
              <span>{t('menu.assignedTraining')}</span>
            </>
          }
        ]
      },
      {
        className: 'volunteer-context-menu-actions',
        items: [
          {
            key: 'remove',
            className: 'volunteer-context-action destructive',
            onClick: props.onRemoveFromTeam,
            content: <>
              <TrashCanIcon />
              <span>{t('menu.removeFromTeam')}</span>
            </>
          }
        ]
      }
    ]}
  />;
}
